// @flow
import React, { Component } from 'react';

import ContentBox from '../ContentBox.jsx';
import PageHeader from '../PageHeader.jsx';
import DrugTable from './DrugTable.jsx';

class ArchivedPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title="Archived" />
        <ContentBox>
          <DrugTable category='archived' />
        </ContentBox>
      </div>
    );
  }
}

export default ArchivedPage;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/ArchivedPage.jsx